import { formatBalance } from '@ui/src';
import { useAppSelector } from '@store';
import { BalanceFrsRowTypes } from './types';

import cn from './balance.module.css';

const BalanceFrsRow = ({
  title,
  amount,
  withHint,
  left,
  right,
}: BalanceFrsRowTypes) => {
  const { baseCurrency } = useAppSelector((state) => state.reportsDictionaries);

  return (
    <div className={cn.balanceFrsRow}>
      <div className={cn.balanceFrsRowValue}>
        <div className={cn.balanceFrsRowValueDescription}>
          {title}
          {withHint && <div className={cn.balaneFrsHint}>i</div>}
        </div>
      </div>
      <div className={cn.balanceFrsRowValue}>
        {amount !== undefined && left
          ? formatBalance(amount, baseCurrency)
          : ''}
      </div>
      <div className={cn.balanceFrsRowValue}>
        {amount !== undefined && right
          ? formatBalance(amount || 0, baseCurrency)
          : ''}
      </div>
    </div>
  );
};

export default BalanceFrsRow;
